import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { memo } from "react";
/** Show the number of active filters in the chip */
function FilterChipNumberComponent(t0) {
  const $ = _c(3);
  const {
    shouldHaveDropdown,
    numberOfActiveFilters
  } = t0;
  if (numberOfActiveFilters === 0 || !shouldHaveDropdown) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "18px",
      height: "18px",
      backgroundColor: "primary.light",
      color: "common.white",
      textAlign: "center",
      borderRadius: "50%",
      marginRight: "6px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== numberOfActiveFilters) {
    t2 = <Box component="div" sx={t1}><var>{numberOfActiveFilters}</var></Box>;
    $[1] = numberOfActiveFilters;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export const FilterChipNumber = memo(FilterChipNumberComponent);